import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {Helmet} from "react-helmet";
import * as api from "../../api";
import TriggersTableHeader from "./triggers-table-header";
import TriggersTableRow from "./triggers-table-row";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

function mapStateToProps(state) {
    return {

    };
}

class Triggers extends Component {

    constructor(props){
        super(props);
        this.state = {
            dataProvider: new ApiDataProvider(api.getTriggersList, [this.props.customerId]),
        }
    }

    render() {
        return (
            <div className="main-container">
                <Helmet>
                    <title>Insite | Triggers</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                                <h2>Triggers</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="triggers" canExport={true}
                                                     headerComponent={TriggersTableHeader} rowComponent={TriggersTableRow}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(Triggers);